import React, { FC } from 'react'

import { IconDownloadProps } from './IconDownload.types'
import * as Styled from './styles/IconDownload.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDownload: FC<IconDownloadProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDownloadProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconDownloadProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M156 112a4 4 0 0 0-4 4v20a16 16 0 0 1-16 16H24a16 16 0 0 1-16-16v-20a4 4 0 0 0-8 0v20a24 24 0 0 0 24 24h112a24 24 0 0 0 24-24v-20a4 4 0 0 0-4-4z' />
        <path d='M77.07 134.72h.05a4 4 0 0 0 .38.33c.08.06.15.13.23.19a4 4 0 0 0 .5.28l.2.11a4 4 0 0 0 .67.21h.09a4 4 0 0 0 1.63 0h.1a4 4 0 0 0 .67-.21l.2-.11a4 4 0 0 0 .49-.27c.08-.06.16-.13.23-.19a4 4 0 0 0 .37-.32h.05l26-28a4 4 0 0 0-5.86-5.44L84 121.81V36a4 4 0 0 0-8 0v85.81l-19.07-20.53a4 4 0 1 0-5.86 5.44z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconDownload
